import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { CheckCircle2, Circle, MapPin } from "lucide-react";
import { formatDate } from "../lib/format";

const STATO_LBL = { aperta: "Aperta", in_lavorazione: "In lavorazione", legale: "Al legale", mediazione: "In mediazione", chiusa: "Chiusa", out: "Chiusa senza seguito" };

const Info = ({ label, value, testId }) => (value ? (
  <div className="text-sm" data-testid={testId}><span className="text-slate-500">{label}: </span><span className="text-slate-100">{value}</span></div>
) : null);

const steps = (p) => {
  const closed = ["chiusa", "out"].includes((p.stato || "").toLowerCase());
  return [
    { l: "Pratica aperta", done: true, d: p.data_apertura },
    { l: "In lavorazione", done: closed || (p.stato || "aperta") !== "aperta" || p.has_quietanza, d: "" },
    { l: "Quietanza / liquidazione ricevuta", done: !!p.has_quietanza, d: p.quietanza_data },
    { l: "Onorari incassati dallo studio", done: !!p.onorari_ricevuti, d: p.data_incasso_onorari },
    { l: p.stato === "out" ? "Chiusa senza seguito" : "Pratica chiusa", done: closed, d: p.data_chiusura },
  ];
};

// Scheda di dettaglio pratica per il segnalatore (solo lettura).
export default function SegPraticaDetail({ p, onClose }) {
  if (!p) return null;
  const veic = [p.veicolo, p.targa].filter(Boolean).join(" — ");
  return (
    <Dialog open={!!p} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md sm:max-w-md w-[calc(100vw-2rem)] bg-[#121824] border-slate-700 text-slate-100" data-testid="seg-pratica-detail">
        <DialogHeader>
          <DialogTitle className="font-head"><span className="font-mono text-amber-400">{p.numero}</span> · {p.cliente}</DialogTitle>
        </DialogHeader>
        <div className="space-y-1.5">
          <Info label="Stato" value={STATO_LBL[(p.stato || "").toLowerCase()] || p.stato} testId="seg-detail-stato" />
          <Info label="Data sinistro" value={[p.data_sinistro && formatDate(p.data_sinistro), p.ora_sinistro && `ore ${p.ora_sinistro}`].filter(Boolean).join(" ")} />
          {p.luogo_sinistro && (
            <div className="text-sm flex items-start gap-1.5" data-testid="seg-detail-luogo"><MapPin className="h-4 w-4 text-amber-400 mt-0.5 shrink-0" /><span className="text-slate-100">{p.luogo_sinistro}</span></div>
          )}
          <Info label="Veicolo" value={veic} />
          <Info label="Compagnia gestionaria" value={p.compagnia_gestionaria} />
        </div>
        <div className="mt-3 border-t border-slate-800 pt-3">
          <div className="text-[11px] font-bold uppercase tracking-widest text-slate-400 mb-2">Stato di avanzamento</div>
          <ol className="space-y-2" data-testid="seg-detail-timeline">
            {steps(p).map((s, i) => (
              <li key={i} className="flex items-start gap-2" data-testid={`seg-detail-step-${i}`}>
                {s.done ? <CheckCircle2 className="h-5 w-5 text-emerald-500 shrink-0" /> : <Circle className="h-5 w-5 text-slate-600 shrink-0" />}
                <div className={`text-sm ${s.done ? "text-slate-100" : "text-slate-500"}`}>
                  {s.l}{s.done && s.d ? <span className="text-xs text-slate-400"> · {formatDate(s.d)}</span> : null}
                </div>
              </li>
            ))}
          </ol>
        </div>
      </DialogContent>
    </Dialog>
  );
}
